module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lj3rq"))).then(() => parcelRequire('jVBUk'));